import { fetchWithDefaults } from "../config/fetchDefault";

let zendeskInitialized = false;

const _createScript = (src) => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script')
		script.src = src
		script.async = true
		script.id = 'ze-snippet'
		script.onload = resolve
		script.onerror = reject
		document.head.appendChild(script)
	})
}

const _queue = []

const _fakezE = (...args) => {
    _queue.push(args)
}

const initZendesk = async (agentInfo, setConversationFields = true) => {
    const {agentCode, organization, firstName, lastName, email , tenantId , organizationName} = agentInfo
    // console.log('attempting initalize zendesk',{args: {agentCode, organization, firstName, lastName, email, setConversationFields}})
    try {
        if (document.getElementById("ze-snippet") || zendeskInitialized) return;

        // console.log('initalizing zendesk')
        
        zendeskInitialized = true;
        await _createScript(`https://static.zdassets.com/ekr/snippet.js?key=${process.env.REACT_APP_ZENDESK_API_KEY}`)
        await loginUser(agentInfo , setConversationFields)
       
        // handle any calls. to zE
        // that were made before
        // the widget was availble
        if (_queue.length > 0) {
            while(_queue.length > 0){
                const args = _queue.shift()
                window.zE(...args)
            }
        }

    } catch (error) {
        console.error("Error initializing Zendesk widget:", error);
    }
}

const getZe = () => {
    return !window.zE ? _fakezE : window.zE
}

const resetZendesk = (cb) => {
    const zE = getZe()
    zE("messenger", "resetWidget", cb())
}

const loginUser = async (agentInfo = null, setConversationFields = false) => {
  const zE = getZe();
  const { agentId} = agentInfo;
  
  zE("messenger", "loginUser",
    async (callback) => { // jwtCallback
      const res = await fetchWithDefaults(`/agents/intercomData?agent=${agentId}`);
      const { zendesk_token , email , name , organization , agent_code , tenant_id = null , orgName = null} = await res.json();
      const organizationName = orgName ? orgName : email?.split("@")[1].split(".")[0];
      callback(zendesk_token);

      if (setConversationFields) {
        const conversationFields = [
          { id: '37445112626715', value: agent_code },
          { id: '34662830922395', value: name },
          { id: '34662826684315', value: email },
          { id: '40394004564123', value: organization || "Unknown" },
          { id: '37486365418011', value: "Web" } 
        ];

        if (tenant_id) {
          conversationFields.push(
            { id: '37486372350107', value: `${tenant_id}` },       
            { id: '40408307594139', value: organizationName}
          );
        }
        //console.log('conversationFields', conversationFields)
         window.zE("messenger:set", "conversationFields", conversationFields);
      }
    },
    (error) => {
      if (error) {
        console.log("Zendesk login error:", error);
      }
    }
  );
};

const logoutUser = () => {
    const zE = getZe()
    zE('messenger', 'logoutUser')
}
export { initZendesk, getZe, resetZendesk, loginUser, logoutUser };
